import { ContactsComponent } from "@/pages/dev/contacts"
import { ContactCRUD } from "@/pages/dev/contacts/contact"
import { agents } from "@/pages/dev/agents"
import { apikeys } from "@/pages/dev/apikeys"
import { apikeys_crud } from "@/pages/dev/apikeys/apikey"
import { dev_dtprops } from "@/pages/dev/demo/tabledemo"
import { logsdev } from "@/pages/dev/agentlogs"
import { models } from "@/pages/dev/models"
import { models_crud } from "@/pages/dev/models/model"
import { projects } from "@/pages/dev/projects"
import { roles } from "@/pages/dev/roles"
import { roles_crud } from "@/pages/dev/roles/role"
import { teams } from "@/pages/dev/teams"
import { teams_crud } from "@/pages/dev/teams/team"
import { users } from "@/pages/dev/users"
import { users_crud } from "@/pages/dev/users/user"
import { profile } from "@/pages/dev/profile"
import { mfaEnroll } from "@/pages/dev/mfa/enroll"
import { Book, Code, FileIcon, FileStack, LayoutList, MessageCircle, MessagesSquare, OctagonAlert, Settings2, Users, type LucideIcon } from "lucide-react"
import { templates } from "@/pages/dev/templates"
import { supademo } from "@/pages/dev/demo/supademo"
import { projects_crud } from "@/pages/dev/projects/project"
import { jobs } from "@/pages/dev/jobs"
import { jobs_crud } from "@/pages/dev/jobs/job"
import { campaigns } from "@/pages/dev/campaigns"
import { campaigns_crud } from "@/pages/dev/campaigns/campaign"

import { supa } from "@/pages/dev/vectors"
import { supacrud } from "@/pages/dev/vectors/vectorcrud"
import { kbsources } from "@/pages/dev/kbsources"
import { kbsources_crud } from "@/pages/dev/kbsources/kbsources_crud"

import { dashboard } from "@/pages/dev/dashboard"
import { smartCMS } from "@/pages/dev/smart-cms"
import { hitl } from "@/pages/dev/moderation"
import { simulator } from "@/pages/dev/simulator"
import { multichat } from "@/pages/multichat"
import { dbricks } from "@/pages/dev/databricks"
import { dabrickscrud } from "@/pages/dev/databricks/databrics_crud"
import { domains } from "@/pages/dev/domains"
import { domains_crud } from "@/pages/dev/domains/domain"
import { services } from "@/pages/dev/services"
import { Eval_Categories } from "@/pages/dev/evaluations/evalcats"
import { Evalcats_CRUD, } from "@/pages/dev/evaluations/evalcats/evalcat"
import { Eval_Items } from "@/pages/dev/evaluations/evalitems"
import { Evalitems_CRUD } from "@/pages/dev/evaluations/evalitems/evalitem"
import { simulation } from "@/pages/dev/evaluations/simulation"
import { EventsComponent } from "@/pages/dev/events"
import { MessagesListComponent } from "@/pages/dev/messages"
import { agentChat } from "@/pages/dev/chat"
import { forms } from "@/pages/dev/forms/indext"
import { forms_crud } from "@/pages/dev/forms/form"
import { channels } from "@/pages/dev/channels"
import { channels_crud } from "@/pages/dev/channels/channel"
import { routers } from "@/pages/dev/routers"
import { routers_crud } from "@/pages/dev/routers/router"
import { agentsChangelog } from "@/pages/dev/agentschangelog"
import { agentsChangelog_crud } from "@/pages/dev/agentschangelog/change"
import { releaseNotesPage } from "@/pages/dev/releasenotes"
import { playbooks } from "@/pages/dev/playbooks"
import { playbooks_crud } from "@/pages/dev/playbooks/playbook"

export const pages: Record<string, PageConfig> = {
  agents,

  dev_dtprops,

  projects,
  projects_crud,


  teams,
  teams_crud,

  apikeys,
  apikeys_crud,

  models,
  models_crud,

  agentsChangelog,
  agentsChangelog_crud,

  users,
  users_crud,

  profile,


  mfaEnroll,

  roles,
  roles_crud,

  supademo,

  jobs,
  jobs_crud,

  campaigns,
  campaigns_crud,


  kbsources,
  kbsources_crud,
  supa,
  supacrud,

  databricks: dbricks,
  dabrickscrud,

  domains,
  domains_crud,

  services,

  evalcats: {
    title: "Classifications",
    description: "Manage your organization's Classifications.",
    route: "/evaluations/evalcats",
    url: "/evaluations/evalcats",
    icon: LayoutList,
    component: Eval_Categories,
    group: "evaluations",
    resource: "classifications",
    action: "read",
  } satisfies PageConfig,

  evalcats_crud: {
    title: "Evaluation Category",
    route: "/evaluations/evalcats/:id",
    component: Evalcats_CRUD,
    group: "evaluations",
    resource: "classifications",
    icon: LayoutList,
    action: "read",
  } satisfies PageConfig,

  evalitems: {
    title: "Evaluation Items",
    description: "Manage your organization's Evaluation Items.",
    route: "/evaluations/evalitems",
    url: "/evaluations/evalitems",
    icon: LayoutList,
    component: Eval_Items,
    group: "evaluations",
    resource: "riskcategories",
    action: "read",
  } satisfies PageConfig,

  evalitems_crud: {
    title: "Evaluation Item",
    route: "/evaluations/evalitems/:id",
    component: Evalitems_CRUD,
    group: "evaluations",
    resource: "riskcategories",
    icon: LayoutList,
    action: "read",
  } satisfies PageConfig,

  simulation,

  dashboard,
  smartCMS,

  hitl,
  simulator,


  logsdev,

  events: {
    title: "Events",
    route: "/events",
    url: "/events",
    icon: OctagonAlert,
    component: EventsComponent,
    group: "dev",
    resource: "events",
    action: "read",
  } satisfies PageConfig,

  contacts: {
    title: "Contacts",
    route: "/contacts",
    url: "/contacts",
    icon: Users,
    component: ContactsComponent,
    group: "chats",
    resource: "contacts",
    action: "read",
  } satisfies PageConfig,

  contacts_crud: {
    title: "Contact",
    route: "/contacts/:id",
    component: ContactCRUD,
    group: "chats",
    resource: "contacts",
    icon: Users,
    action: "read",
  } satisfies PageConfig,


  messages: {
    title: "Messages",
    description: "View your organization's messages.",
    route: "/messages",
    url: "/messages",
    icon: MessageCircle,
    component: MessagesListComponent,
    group: "chats",
    resource: "messages",
    action: "read",
  } satisfies PageConfig,

  agentChat,

  multichat,

  forms,
  forms_crud,

  channels,
  channels_crud,

  routers,
  routers_crud,

  releaseNotesPage,

  playbooks,
  playbooks_crud,

}

export const groups = {
  chats: { title: "Chats", icon: MessageCircle },
  evaluations: { title: "Evaluations", icon: LayoutList },
  knowledge: { title: "Knowledge", icon: Book },
  docs: { title: "Knowledge", icon: FileIcon },
  communications: { title: "Communications", icon: MessagesSquare },
  settings: { title: "Settings", icon: Settings2 },
  dev: { title: "Dev", icon: Code },
} satisfies Record<string, Group>

declare global {

  type PermissionAction = 'create' | 'read' | 'update' | 'delete' | 'share'

  interface Group {
    title: string
    icon?: LucideIcon
  }

  interface PageConfig {
    title: string
    description?: string
    route: string
    url?: string
    icon?: LucideIcon
    component?: React.ComponentType
    group?: keyof typeof groups
    resource?: LiteralUnion<"agents" | "templates" | "playground" | "hitl" | "logs" | "collections" | "sources" | "projects" | "teams" | "roles" | "users" | "apikeys" | "models" | "contacts" | "messages" | "events" | "jobs" | "dashboard" | "classifications" | "forms" | "riskcategories" | "simulator" | "simulations" | "agentchat" | "channels">
    action?: PermissionAction
  }

}
